function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * done
 */

import { useField } from '@formily/react';
import React, { useCallback } from 'react';
import { wrapReactionHook, useParams, useClear } from "../../hooks";
import { Checkbox, Radio } from 'antd';
import { useDict } from "../../hooks/useDict";
import { DictText } from "../DictText";
export var DictRadio = wrapReactionHook(function (props) {
  var _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    _props$childrenLoadLe = props.childrenLoadLevel,
    childrenLoadLevel = _props$childrenLoadLe === void 0 ? 5 : _props$childrenLoadLe,
    dictType = props.dictType,
    dictMap = props.dictMap,
    autoRemoveDict = props.autoRemoveDict,
    onChange = props.onChange,
    value = props.value,
    multiple = props.multiple,
    url = props.url,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'row' : _props$direction,
    _props$autoClear = props.autoClear,
    autoClear = _props$autoClear === void 0 ? [] : _props$autoClear,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    readOnly = props.readOnly,
    disabled = props.disabled;
  var field = useField();
  var getParams = useParams(params);
  var clear = useClear(autoClear);
  var enums = field && field.dataSource;
  var dictParams = {
    level: level,
    childrenLoadLevel: childrenLoadLevel,
    url: url,
    params: getParams(),
    autoRemoveDict: autoRemoveDict,
    dictMap: dictMap,
    enums: enums
  };
  var options = useDict(dictType, dictParams);
  var handleChange = useCallback(function (event) {
    clear();
    onChange(event);
  }, [clear, onChange]);
  var isEmpty = Array.isArray(value) ? value.length === 0 : value === undefined || value === null || value === '';
  if (readOnly) {
    return /*#__PURE__*/React.createElement("div", null, isEmpty ? '-' : /*#__PURE__*/React.createElement(DictText, _extends({}, dictParams, {
      dictType: dictType,
      value: value
    })));
  }
  var typeMap = {
    button: 'button',
    radio: 'default'
  };
  if (multiple) {
    return /*#__PURE__*/React.createElement(Checkbox.Group, {
      value: value,
      onChange: handleChange,
      disabled: disabled
    }, options.map(function (i) {
      return /*#__PURE__*/React.createElement(Checkbox, {
        value: i.value,
        key: i.value
      }, i.label);
    }));
  }
  return /*#__PURE__*/React.createElement(Radio.Group, {
    optionType: typeMap[type] || 'button',
    value: value,
    onChange: handleChange,
    disabled: disabled
  }, options.map(function (i) {
    return /*#__PURE__*/React.createElement(Radio, {
      value: i.value,
      key: i.value
    }, i.label);
  }));
});